import Typography from "../../../../core/Typography";
import { useDevice } from "../../../customHooks";

export const Caption = () => {
  let device = useDevice();
  return (
    <>
      <Typography
        type={device === "mobile" ? "h6" : "h5"}
        font="inter"
        colorStep={100}
        tagName="div"
      >
        Payment form
      </Typography>
      <Typography
        type={device === "mobile" ? "caption" : "body"}
        font="inter"
        colorStep={50}
        tagName="div"
        large={device !== "mobile"}
      >
        In case you want to charge users
      </Typography>
    </>
  );
};
